import z from 'zod'

export const tabItems = [
  'bppsdmp',
  'bbpsip-bpsip',
  'province',
  'city',
  'district'
] as const

export const searchParamsSchema = z.object({
  tab: z
    .enum(['bppsdmp', 'bbpsip-bpsip', 'province', 'city', 'district'])
    .optional()
    .default('bppsdmp')
    .transform(val => val as (typeof tabItems)[number]),
  instansi_id: z.string().optional(),
  province_code: z.string().optional(),
  city_code: z.string().optional(),
  district_code: z.string().optional(),
  search: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  per_page: z.coerce.number().optional().default(10),
  // should be an id of the reference item as its value
  bpp: z.string().optional(),
  agency: z.string().optional(),
  type: z.string().optional(),
  gender: z.string().optional(),
  position: z.string().optional(),
  skill: z.string().optional(),
  status: z.string().optional(),
  education: z.string().optional()
})

export type SearchParams = z.infer<typeof searchParamsSchema>

export type TabItem = (typeof tabItems)[number]
